export default __webpack_public_path__ + "static/media/36I-114288_-21000_0.6d532fca.jpg";